export const assignmentsData = [
    {
      Key: 1,
      TotalSubmit: "2",
      TotalMark: "80",
      Assignments: "Building Your First Landing Page",
      AssignmentsNotes: "Course: Sketch from A to Z (2024): Become an app designer",
      Status: "Published",
    },
    {
      Key: 2,
      TotalSubmit: "4",
      TotalMark: "60",
      Assignments: "Building a Basic Angular Application",
      AssignmentsNotes: "Course: Learn Angular Fundamentals Beginners Guide",
      Status: "Draft",
    },
    {
      Key: 3,
      TotalSubmit: "3",
      TotalMark: "30",
      Assignments: "Basic Arithmetic Operations",
      AssignmentsNotes: "Course: Learn JavaScript and Express to become a Expert",
      Status: "Published",
    },
    {
      Key: 4,
      TotalSubmit: "5",
      TotalMark: "50",
      Assignments: "Basic Calculations",
      AssignmentsNotes: "Course: Learn JavaScript and Express to become an Expert",
      Status: "Published",
    },
  ];
  